export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';
export const CLOSE_SIDEBAR = 'CLOSE_SIDEBAR';
export const OPEN_USER_BAR = 'OPEN_USER_BAR';
export const CLOSE_USER_BAR = 'CLOSE_USER_BAR';
export const NAVIGATION_INIT = 'NAVIGATION_INIT';


// WEBPACK FOOTER //
// ./src/core/services/navigation/action-types.js